import { Button, InputNumber, Tag } from 'antd'
import React from 'react'
import ProductImage from '../../../components/shared/ProductImage'
import { getVenueCustomImageUrl } from 'src/utils/venueProductImage'

const BasketTableColumn = (
  selectedProducts,
  handleRemoveProduct,
  onChangeQuantity,
  updateLoading,
  removeProductId,
  isPricesHidden,
) => {
  return [
    {
      title: '',
      dataIndex: 'product.cloudinaryImageId',
      key: 'cloudinaryImageId',
      width: '7%',
      render: (_, product) => {
        // Venue's own photo overrides the supplier image
        const customImageUrl = getVenueCustomImageUrl(product?.venueProduct)
        if (customImageUrl) {
          return (
            <img
              src={customImageUrl}
              width={60}
              height={60}
              style={{ borderRadius: 10, objectFit: 'cover' }}
              alt=''
            />
          )
        }
        return <ProductImage imageId={product?.product?.cloudinaryImageId} />
      },
    },
    {
      title: 'Title',
      key: 'title',
      width: '25%',
      onHeaderCell: () => ({
        style: { minWidth: '10rem' },
      }),
      onCell: () => ({
        style: { minWidth: '10rem', overflowWrap: 'anywhere' },
      }),
      render: (_, item) => {
        return item?.venueProduct?.title || item?.product?.title
      },
    },
    {
      title: 'Size',
      dataIndex: 'product.size',
      key: 'size',
      width: '14%',
    },
    {
      title: 'Price',
      dataIndex: '',
      key: 'price',
      width: '10%',
      render: (_, item) => {
        if (isPricesHidden) return ''

        // Show base price (without VAT) for consistency with minimum checks
        const basePrice = item?.isSpecialOrder
          ? Number(item.specialProductPrice) || 0
          : item?.brakesPrice !== undefined &&
            !isNaN(item?.brakesPrice) &&
            Number(item?.brakesPrice) > 0
          ? Number(item.brakesPrice)
          : item.product && item.product.price
          ? Number(item.product.price)
          : 0

        const hasVat = item?.product?.hasVat || false

        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <span>£{basePrice.toFixed(2)}</span>
            {hasVat && (
              <Tag
                color='blue'
                style={{ fontSize: '11px', margin: 0, padding: '0 4px' }}
              >
                VAT
              </Tag>
            )}
          </div>
        )
      },
    },
    // {
    //   title: 'Delivery Fee',
    //   key: 'DeliveryFee',
    //   width: '10%',
    //   render: item => {
    //     return item?.venueSuppplier?.deliveryFee
    //       ? item?.venueSuppplier?.deliveryFee
    //       : 0
    //   },
    // },
    {
      title: 'Supplier',
      dataIndex: 'product.supplier.title',
      key: 'supplierTitle',
      width: '22%',
    },
    {
      title: 'SKU',
      dataIndex: 'product.sku',
      key: 'sku',
      width: '7%',
      onHeaderCell: () => ({
        style: { whiteSpace: 'nowrap', minWidth: '4.5rem' },
      }),
      onCell: () => ({
        style: { whiteSpace: 'nowrap', minWidth: '4.5rem' },
      }),
    },
    {
      title: 'Amount',
      dataIndex: 'product.quantity',
      key: 'quantity',
      width: '8%',
      onHeaderCell: () => ({
        style: { whiteSpace: 'nowrap', minWidth: '4.5rem' },
      }),
      render: (_, product) => (
        <InputNumber
          style={{ width: 50 }}
          value={product.quantity}
          onChange={value => onChangeQuantity(value, product)}
        />
      ),
    },
    {
      title: 'Action',
      key: 'remove',
      width: '8%',
      render: (_, product) => (
        <Button
          loading={updateLoading && removeProductId === product._id}
          type={'danger'}
          onClick={() => handleRemoveProduct(product)}
        >
          Remove
        </Button>
      ),
    },
  ]
}

export default BasketTableColumn
